import { render, staticRenderFns } from "./RosieView.vue?vue&type=template&id=96e43a84&"
import script from "./RosieView.vue?vue&type=script&lang=js&"
export * from "./RosieView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports